import { Routes } from '@angular/router';
import { AlgorithmPage } from './algorithm-page';

export const mechanicAlgorithmRoutes: Routes = [
  {
    path: '',
    component: AlgorithmPage,
  },
];
